module.exports = __webpack_public_path__ + "img/9788925543376.1ac5812d.jpg";